import 'core-js/es6/promise';
import 'isomorphic-fetch';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import * as storage from 'localforage';
import * as PropTypes from 'prop-types';
import { ApolloProvider } from 'react-apollo';
import { Provider } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import {
    BrowserRouter as Router,
    Route,
} from 'react-router-dom';

import App from './App';
import env from './env';
import { startSegment } from './helpers/segment';
import createStore from './reducers';
import PrivateContainer, {
    PrivateContainerProps,
} from './sections/Login/PrivateContainer';
import { createClient } from './services/MessageTemplatesService';
import { ConversationUrlParams } from './types';

// Setup Promise and Fetch everywhere
require('es6-promise/auto');
require('viewport-units-buggyfill').init();

// avoids proxy inline script issue in app.statflo.com/messenger
if (window.hasOwnProperty('Typekit')) {
    (window as any).Typekit.load({ async: true });
}

if (env.SEGMENT_KEY) {
    startSegment();
}

interface AuthCheckProps extends RouteComponentProps<ConversationUrlParams>, PrivateContainerProps { }

const ROOT_ELEMENT = document.getElementById('root');

storage.config({
    driver: storage.INDEXEDDB,
    name: env.STORAGE_KEY
});

const AuthProvider = PrivateContainer((props) => <div>{props.children}</div>);

const RefreshToBindSSO = () => window.location.href = env.CONVERSATION_UI_DEV || `${env.WEBAPP_HOST}messenger`;

const AuthCheck: React.StatelessComponent<AuthCheckProps> = (props, context) => context.session ? (
    <ApolloProvider client={createClient(context.session)} >
        <App {...(props as AuthCheckProps)} />
    </ApolloProvider>
) : null;

AuthCheck.contextTypes = {
    session: PropTypes.any
};

// window.addEventListener('storage', function (event) {
//     if (event.key === 'statflo-logout-event') {
//         window.close();
//     }
// }, false);

export const store = createStore();

const render = () => {
    ReactDOM.render(
        <Provider store={store}>
            <AuthProvider>
                <Router basename={window.location.href.match(env.WEBAPP_HOST) ? 'messenger' : ''}>
                    <div>
                        <Route path="/login" component={RefreshToBindSSO} />
                        <Route path="/" component={AuthCheck} />
                    </div>
                </Router>
            </AuthProvider>
        </Provider>,
        ROOT_ELEMENT
    );
};

if (
    'Map' in window &&
    'Set' in window &&
    'includes' in String.prototype &&
    'find' in Array.prototype &&
    'includes' in String.prototype
) {
    render();
} else {
    import('./polyfills').then(render);
}



// WEBPACK FOOTER //
// ./src/index.tsx